import { AxiosResponse } from 'axios'
import { apiNode } from './api'
import {
	AcceptInviteRequest,
	InviteAcceptResponseData,
} from './types/invite.interfaces'

const URL = '2/invites'

export const InviteService = {
	async acceptInvite({
		mode,
		...data
	}: AcceptInviteRequest): Promise<InviteAcceptResponseData> {
		const url =
			mode === 'anonymous'
				? `${URL}/accept`
				: `${URL}/user/accept`
		const response: AxiosResponse<InviteAcceptResponseData> =
			await apiNode.post<InviteAcceptResponseData>(url, data)

		return response.data
	},
}
